import React from "react";
import FooterLanding from "../../components/base/landing/footer";
import Opiniones from "../../components/base/landing/opiniones";
import Navbar from "../../components/base/landing/navbar";
import { useLocation } from "react-router-dom";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";


const OpinionesPage = () => {
  const location = useLocation(); // Asegúrate de importar useLocation desde react-router-dom
  return (
    <>
      <Navbar location={location} />
      <Opiniones />
      <FooterLanding />
      <BlogButton/>
      <WhatsApp/>
    </>
  );
};

export default OpinionesPage;
